import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import * as model from "../../../models";

@Component({
	selector: 'event-status-presentation',
	templateUrl: "./event-status.presentation.html",
	styles: [require("./event-status.presentation.scss")]
})
export class EventStatusPresentation {
	@Input() event: model.Event
	@Input() lifecyclePhaseName: string
	@Output() setToSaleable = new EventEmitter<void>()
	@Output() setToSuspended = new EventEmitter<void>()
	@Output() cancelEventConfirmed = new EventEmitter<string>()
	@Output() setToFinished = new EventEmitter<void>()

	@Output() setToSaleableSupport = new EventEmitter<void>()


	private LIFECYCLE_PHASES = model.Event.LIFECYCLE_PHASES

	private showCancellationPopup = false;
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-status/event-status.presentation.ts